// matches a run of non-breaking spaces plus the single regular space this helper appends, so re-running is stable
const NBSP_RUN = /(?:&nbsp;|\u00a0)+ ?/g;
const NBSP_ENTITY = /&nbsp;/g;

// getSemanticHTML() escapes every space as &nbsp; (slab/quill#4509); make interior runs breakable, leave tag-adjacent ones alone
export const normalizeQuillSpaces = (htmlString: string): string => {
	return htmlString.replace(NBSP_RUN, (run, offset: number, source: string) => {
		const before = source[offset - 1];
		const after = source[offset + run.length];
		// html collapses leading/trailing spaces, so a run against a tag boundary has to stay non-breaking
		if (!before || !after || before === '>' || after === '<') {
			return run;
		}

		const count = run.replace(NBSP_ENTITY, '\u00a0').length;
		if (count <= 1) {
			return ' ';
		}
		return '&nbsp;'.repeat(count - 1) + ' ';
	});
};
